
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useRegistration } from "@/hooks/useRegistration";
import { RegistrationFields } from "./form/RegistrationFields";

interface RegisterFormProps {
  businessTypes: any[];
  isLoadingBusinessTypes: boolean;
}

export const RegisterForm = ({ businessTypes, isLoadingBusinessTypes }: RegisterFormProps) => {
  const [selectedBusinessType, setSelectedBusinessType] = useState<string>("");
  const [fullName, setFullName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("FCFA");
  
  const { registerUser, isLoading } = useRegistration();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await registerUser({
        email,
        password,
        fullName,
        companyName,
        selectedBusinessType,
        selectedCurrency,
      });
    } catch (error) {
      // Error is handled in the hook
      console.error("Error during registration:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <RegistrationFields
        fullName={fullName}
        setFullName={setFullName}
        companyName={companyName}
        setCompanyName={setCompanyName}
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        selectedBusinessType={selectedBusinessType}
        setSelectedBusinessType={setSelectedBusinessType}
        selectedCurrency={selectedCurrency}
        setSelectedCurrency={setSelectedCurrency}
        businessTypes={businessTypes}
      />

      <Button 
        type="submit" 
        className="w-full"
        disabled={!selectedBusinessType || isLoadingBusinessTypes || isLoading}
      >
        {isLoading ? "Inscription en cours..." : "S'inscrire"}
      </Button>
    </form>
  );
};
